import {
  Dialog,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./list.module.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ChevronDown, ChevronUp, Code, User, X } from "react-feather";

const List = ({ allData, filterData, setEditModalOpen, setEditData }) => {
  const redirect = useHistory();
  const [filterredData, setFilterredData] = useState([]);
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [carImage, setCarImage] = useState("");
  const [openPop, setOpenPop] = useState(false);

  const handleOpen = () => {
    setOpenPop(true);
  };
  const handleClose = () => {
    setOpenPop(false);
  };

  console.log(carImage);
  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  };

  useEffect(() => {
    let filterredDataTemp = allData;

    if (filterData?.searchKey !== "") {
      let inputVal = filterData?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredDataTemp = filterredDataTemp.filter(
        (item) =>
          item?.tenant_id &&
          (item?.tenant_name.toLowerCase().includes(inputVal) ||
            item?.property_name.toLowerCase().includes(inputVal) ||
            item?.apt_no.toLowerCase().includes(inputVal) ||
            item?.type.toLowerCase().includes(inputVal) ||
            item?.weight.toLowerCase().includes(inputVal) ||
            item?.title.toLowerCase().includes(inputVal))
      );
    }

    if (filterData?.property !== "" && filterData?.property !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.property_id === filterData.property
      );
    }

    if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i.apt_id === filterData.apartment
      );
    }

    if (filterData?.type !== "" && filterData?.type !== "all") {
      filterredDataTemp = filterredDataTemp.filter(
        (i) => i?.is_guest === filterData.type
      );
    }

    setFilterredData(filterredDataTemp);
  }, [allData, filterData]);

  const goToDetails = (item) => {
    setEditModalOpen(true);
    setEditData(item);
    // redirect.push("/people/tenants/details/" + item.tenant_id);
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCarImage("");
  };
  const open = Boolean(anchorEl);

  const isWithin30Days = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
    return diffInDays <= 30;
  };

  return (
    <div className={`${styles.IncomeListUnderSec}`}>
      <div className={`${styles.ListCardDivSec}`}>
        {filterredData.map((item) => {
          const showBadge = isWithin30Days(item.created_at);
          return (
            <div
              className={`${styles.CardDivList}`}
              onClick={(e) => {
                setEditModalOpen(true);
                setEditData(item);
              }}
            >
              <div
                className={`${styles.FirstSec} ${styles.ProfileImg}`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  redirect.push("/people/tenants/details/" + item.tenant_id);
                }}
              >
                {item?.tenant_id ? (
                  <>
                    {item?.tenant_image !== "" ? (
                      <img src={item?.tenant_image} alt="" />
                    ) : (
                      <div className={`${styles.ProNameIMG}`}>
                        <p>{item?.tenant_initial}</p>
                      </div>
                    )}
                  </>
                ) : (
                  <div className={`${styles.ProNameIMG}`}>
                    <User />
                  </div>
                )}
                <div>
                  <p className={`${styles.Name} ${styles.Hover}`}>
                    {item?.tenant_id ? <>{item?.tenant_name}</> : "-"}
                  </p>
                  <p
                    className={`${styles.Name} ${styles.Hover}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      redirect.push("/properties/details/" + item?.property_id);
                    }}
                  >
                    {item.property_name} - {item.apt_no}
                  </p>
                </div>
              </div>
              <div className={`${styles.SecondSec}`}>
                <p
                  className={`${styles.Name}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCarImage(item?.image_path);
                    handleOpen();
                  }}
                >
                  Pets Name: <span>{item.title}</span>
                  {item?.image_path && (
                    <img src={item?.image_path} alt="" className={`${styles.CarImgForSmall}`} />
                  )}
                </p>
                <p className={`${styles.Name}`}>
                  Type: <span>{item.type}</span> Weight: <span>{item.weight}kg</span> Color: <span>{item.color}</span>
                </p>
              </div>
              <div className={`${styles.ThirdSec}`}>
                {showBadge && (<span className={styles.NewBadge}>New</span>)}
              </div>
            </div>
          );
        })}
      </div>

      {filterredData?.length > 0 && (
        <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 300 }}
                  onClick={(e) => changeSortOrder("tenant_name")}
                >
                  Tenant
                  {sortItem === "tenant_name" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "tenant_name" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "tenant_name" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 200 }}
                  onClick={(e) => changeSortOrder("title")}
                >
                  Pets Name
                  {sortItem === "title" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "title" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "title" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("type")}
                >
                  Type
                  {sortItem === "type" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "type" && sortOrder === "desc" && <ChevronUp />}
                  {sortItem !== "type" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("weight")}
                >
                  Weight
                  {sortItem === "weight" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "weight" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "weight" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 200 }}
                  onClick={(e) => changeSortOrder("color")}
                >
                  Color
                  {sortItem === "color" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "color" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "color" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>

                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 200 }}
                  onClick={(e) => changeSortOrder("property_name")}
                >
                  Property
                  {sortItem === "property_name" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "property_name" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "property_name" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
                <TableCell
                  className={`${styles.TableHead}`}
                  style={{ width: 150 }}
                  onClick={(e) => changeSortOrder("apt_no")}
                >
                  Unit
                  {sortItem === "apt_no" && sortOrder === "asc" && (
                    <ChevronDown />
                  )}
                  {sortItem === "apt_no" && sortOrder === "desc" && (
                    <ChevronUp />
                  )}
                  {sortItem !== "apt_no" && (
                    <Code className={`${styles.Normal}`} />
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterredData
                .sort((a, b) => {
                  if (sortItem === "tenant_name") {
                    return sortOrder === "desc"
                      ? !a.tenant_name?.trim()
                        ? 1
                        : !b.tenant_name?.trim()
                          ? -1
                          : a.tenant_name.toLowerCase() <
                            b.tenant_name.toLowerCase()
                            ? 1
                            : -1
                      : !a.tenant_name?.trim()
                        ? 1
                        : !b.tenant_name?.trim()
                          ? -1
                          : a.tenant_name.toLowerCase() >
                            b.tenant_name.toLowerCase()
                            ? 1
                            : -1;
                  } else if (sortItem === "title") {
                    if (sortOrder === "desc") {
                      return a?.title < b?.title ? 1 : -1;
                    } else {
                      return a?.title > b?.title ? 1 : -1;
                    }
                  } else if (sortItem === "type") {
                    if (sortOrder === "desc") {
                      return a?.type?.localeCompare(b?.type);
                    } else {
                      return b?.type?.localeCompare(a?.type);
                    }
                  } else if (sortItem === "weight") {
                    if (sortOrder === "desc") {
                      return Number(b?.weight) - Number(a?.weight); // larger first
                    } else {
                      return Number(a?.weight) - Number(b?.weight); // smaller first
                    }
                  } else if (sortItem === "color") {
                    if (sortOrder === "desc") {
                      return a?.color?.localeCompare(b?.color);
                    } else {
                      return b?.color?.localeCompare(a?.color);
                    }
                  } else if (sortItem === "property_name") {
                    if (sortOrder === "desc") {
                      return a.property_name < b.property_name ? 1 : -1;
                    } else {
                      return a.property_name > b.property_name ? 1 : -1;
                    }
                  } else if (sortItem === "apt_no") {
                    if (sortOrder === "desc") {
                      return a.apt_no < b.apt_no ? 1 : -1;
                    } else {
                      return a.apt_no > b.apt_no ? 1 : -1;
                    }
                  } else {
                    return (b?.list_id ?? 0) - (a?.list_id ?? 0);
                  }
                })
                .map((item) => {
                  const showBadge = isWithin30Days(item.created_at);
                  return (
                    <TableRow onClick={(e) => goToDetails(item)}>
                      <TableCell
                        className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          redirect.push(
                            "/people/tenants/details/" + item.tenant_id
                          );
                        }}
                      >
                        {item?.tenant_id ? (
                          <>
                            <div className={`${styles.TenantInside}`}>
                              {item?.tenant_image !== "" ? (
                                <img src={item?.tenant_image} alt="" />
                              ) : (
                                <div className={`${styles.ProNameIMG}`}>
                                  <p>{item?.tenant_initial}</p>
                                </div>
                              )}
                              <span>{item?.tenant_name}</span>
                              {showBadge && (<span className={styles.NewBadge}>New</span>)}
                            </div>
                          </>
                        ) : (
                          <div className={`${styles.TenantInside}`}>
                            <div className={`${styles.ProNameIMG}`}>
                              <User />
                            </div>{" "}
                            -
                          </div>
                        )}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText} ${styles.CarImg}`} onMouseEnter={(e) => {
                        setCarImage(item?.image_path);
                        handlePopoverOpen(e);
                      }}
                        onMouseLeave={handlePopoverClose}>
                        {item?.title}
                        {item?.image_path && (
                          <img src={item?.image_path} alt="" />
                        )}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item?.type}
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item?.weight}kg
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item?.color}
                      </TableCell>

                      <TableCell
                        className={`${styles.TableBodyText} ${styles.Hover}`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          redirect.push(
                            "/properties/details/" + item?.property_id
                          );
                        }}
                      >
                        <span>{item.property_name}</span>
                      </TableCell>
                      <TableCell className={`${styles.TableBodyText}`}>
                        {item.apt_no}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <div className={`${styles.ListMobileView}`}>
        {filterredData.map((item) => {
          const showBadge = isWithin30Days(item.created_at);
          return (
            <div className={`${styles.MaintenanceReqCard}`} onClick={(e) => {
              setEditModalOpen(true);
              setEditData(item);
            }}>
              <div className={`${styles.CardImgSec} Secondary`} onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setCarImage(item?.image_path);
                handleOpen();
              }}>
                {item?.image_path && (
                  <img src={item?.image_path} alt="" />
                )}
              </div>
              <div className={`${styles.MainReCardCon}`}>
                <div>
                  <p className={`${styles.Title}`}>
                    {item?.tenant_id ? (<><span onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      redirect.push("/people/tenants/details/" + item.tenant_id);
                    }}>{item?.tenant_name}</span></>) : ('')} {item.title}
                  </p>
                  {parseInt(item?.is_guest) === 1 && (<span className={`${styles.PublishBadge}`}>Guest</span>)}
                  <div className={`${styles.MainReCardIdStatus}`}>
                    <p className={`${styles.MainReID}`}>{item.type} <span>{item.weight}kg</span><span>{item.color}</span></p>
                  </div>
                  <div className={`${styles.MainReCardIdStatus}`}>
                    <p className={`${styles.MainReID} ${styles.Hover}`} onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      redirect.push("/properties/details/" + item?.property_id);
                    }}>{item.property_name} - {item.apt_no}</p>
                    {showBadge && (<span className={styles.NewBadge}>New</span>)}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {filterredData.length === 0 && (
        <div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/pawprint.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Unfortunately!</p>
          <p className={`${styles.NoDataTextSub}`}>
            we couldn't find any pet at this time.
          </p>
        </div>
      )}

      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: "none" }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
        </div>
      </Popover>

      <Dialog
        open={openPop}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`${styles.PopupImgSec}`}>
          <img src={carImage} alt="" />
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleClose();
            }}
          >
            <X />
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default List;
